import { createContext } from 'react';

interface DescriptionListContextType {
  compact: boolean;
  divided: boolean;
  striped: boolean;
}

export const DescriptionListContext = createContext<DescriptionListContextType>(
  {} as DescriptionListContextType
);
